var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prompt)?_c('prompt',{ref:_vm.prompt.class,attrs:{"parentData":{ prompt: _vm.prompt }},on:{"customize-prompt":_vm.customizePrompt,"close-modal":_vm.closeModal}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }